import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { SiteConfigurationTemplate, TagMapping } from '../../../types';
import { StatusChip } from '../StatusChip';
import { EmptySection } from '../EmptySection';
import { useTagMappingStatus } from 'src/features/sites/hooks';

type SitePreviewSectionProps = {
  template: SiteConfigurationTemplate;
  tagMapping: TagMapping;
};

export const SitePreviewSection = ({ template, tagMapping }: SitePreviewSectionProps) => {
  const { isBlockingUnmapped, tagNameLookup } = useTagMappingStatus(template, tagMapping);

  const rows = template.sitePreview.tags;
  if (!rows.length) return <EmptySection label="Site Preview" />;

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Tag</TableCell>
            <TableCell>Column</TableCell>
            <TableCell align="right">Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((entry, index) => {
            // In template → must be mapped; not in template → treat as included (can't verify)
            const included = !isBlockingUnmapped(entry.tagIdempotencyKey);
            const label =
              tagNameLookup[entry.tagIdempotencyKey] || entry.tagName || entry.tagIdempotencyKey;

            return (
              <TableRow key={entry.tagIdempotencyKey}>
                <TableCell>{label}</TableCell>
                <TableCell>{index + 1}</TableCell>
                <TableCell align="right">
                  <StatusChip included={included} />
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
